import { appLocales } from '../i18n';
import { setLang } from './preloadHintCookie';
import { pathnameChecker } from './url';

const setLanguage = (lang: string) => {
  window.localStorage.removeItem('lang');
  const langValue = appLocales.includes(lang) ? lang : 'vi';
  setLang(langValue);
};

const checkReferrerForMarketPage = () => {
  if (!document.referrer) {
    setLanguage('vi');
    return;
  }
};

const setLanguageInLocalStorage = (search: { lang?: string }, pathname: string, cb?: (language: string) => void) => {
  if (search?.lang) {
    setLanguage(search.lang.slice(0, 2));
    if (cb) cb(search.lang.slice(0, 2));
  } else {
    if (pathnameChecker.isProductPage(pathname)) {
      setLanguage('vi');
      if (cb) cb('vi');
    } else if (pathnameChecker.isCategoryPage(pathname)) {
      if (cb) cb('vi');
      checkReferrerForMarketPage();
    }
  }
};

export default setLanguageInLocalStorage;
